import React from 'react';
import { DatePicker, Button, Space } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { addMonths, subMonths } from 'date-fns';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br'; // Importa os dados de localização para o Day.js

// Importa o objeto de localização oficial do Ant Design para o DatePicker
import locale from 'antd/es/date-picker/locale/pt_BR';

import './SeletorDeMes.css';

/**
 * Componente padronizado para navegação de mês.
 * Recebe 'value' (um objeto Date) e 'onChange' (uma função de callback).
 */
const SeletorDeMes = ({ value, onChange }) => {

  const handlePrevMonth = () => {
    if (onChange) onChange(subMonths(value, 1));
  };

  const handleNextMonth = () => {
    if (onChange) onChange(addMonths(value, 1));
  };

  const handlePickerChange = (dayjsObject) => {
    if (dayjsObject && onChange) {
      onChange(dayjsObject.toDate());
    }
  };

  return (
    <Space className="seletor-de-mes">
      <Button icon={<LeftOutlined />} onClick={handlePrevMonth} aria-label="Mês anterior" />
      <DatePicker
        picker="month"
        value={value ? dayjs(value) : null}
        onChange={handlePickerChange}
        format="MMMM / YYYY"
        allowClear={false}
        className="seletor-de-mes-datepicker"
        // Propriedade 'locale' para garantir que o popup e a exibição estejam em português
        locale={locale}
      />
      <Button icon={<RightOutlined />} onClick={handleNextMonth} aria-label="Próximo mês" />
    </Space>
  );
};

export default SeletorDeMes;